<template>
  <div class="my-0">
     <v-menu
      v-model="menu1"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="225px"
      close-delay
      :disabled="disabled"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            :color="!disabled ? bgColor : 'orange lighten-4 dark-0'"
            class="elevation-0 white--text"
          >
            <v-icon v-if="filterIcon" class="mr-2">{{filterIcon}}</v-icon>
            {{dateStart}} ~ {{dateEnd}}
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item-group color="primary" v-model="model">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              nudge-top="325"
              nudge-left="225"
              transition="scale-transition"
              offset-x
              min-width="290px"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-list-item link v-bind="attrs" v-on="on">
                <v-list-item-action>
                  <v-list-item-title>Custom</v-list-item-title>
                </v-list-item-action>
              </v-list-item>
            </template>
            <v-card>
              <v-date-picker           
                show-current="false"
                v-model="pickerDateStart" 
                :allowed-dates="allowedDateEnd"
                :color="bgColor"
              >
              </v-date-picker>
              <v-date-picker           
                show-current="false"
                v-model="pickerDateEnd" 
                :allowed-dates="allowedDateEnd"
                :color="bgColor"        
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  :color="bgColor"
                  @click="getRange('custom')"
                  class="ml-auto"
                >
                  Apply
                </v-btn>
              </v-date-picker>
            </v-card>
          </v-menu>
          <v-list-item
            link
            @click="getRange('period')"
          >
            <v-list-item-action>
              <v-list-item-title>Previous period</v-list-item-title>
            </v-list-item-action>
          </v-list-item>
          <v-list-item
            link
            @click="getRange('year')"
          >
            <v-list-item-action>
              <v-list-item-title>Previous year</v-list-item-title>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    start: {
      type: String
    },
    end: {
      type: String
    },
    diffDays: {
      type: Number
    },
    bgColor: {
      type: String,
      default: 'orange dark-3'
    },
    filterIcon: {
      type: String
    },
    periodStart: {
      type: String
    },
    periodEnd: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
    data() {
    return {
      menu1: false,
      menu2: false,
      model: 1,
      dates: [new Date().toISOString().substr(0, 10)],
      pickerDateStart: new Date().toISOString().substr(0, 10),
      pickerDateEnd: new Date().toISOString().substr(0, 10),
      dateStart: this.start,
      dateEnd: this.end,
      diff: this.diffDays
    }
  },
  mounted() {

  },
  watch: {
    start() {
      if (this.model == 1) {
        this.dateStart = this.start
        this.dateEnd = this.end
        this.$emit('getDates', { dateStart: this.dateStart, dateEnd: this.dateEnd})
      }
    },
    end() {
      if (this.model == 1) {
        this.dateStart = this.start
        this.dateEnd = this.end
        this.$emit('getDates', { dateStart: this.dateStart, dateEnd: this.dateEnd})
      }

    },
    diffDays(){
      this.diff = this.diffDays
    },
    periodStart(){
      if (this.model == 2) {
        let d = moment(this.periodStart)
        this.dateStart = new Date(
                                  Date.UTC(
                                    new Date(d).getFullYear() - 1,
                                    new Date(d).getMonth(),
                                    new Date(d).getDate())
                                  ).toISOString().substr(0, 10)
      }
    },
    periodEnd(){
      if (this.model == 2) {
        let d = moment(this.periodEnd)
        this.dateEnd = new Date(
                        Date.UTC(
                          new Date(d).getFullYear() - 1,
                          new Date(d).getMonth(),
                          new Date(d).getDate())
                        ).toISOString().substr(0, 10)
      }
    }
  },
  methods: {
      allowedDateEnd(val) {
          return  new Date(val).toISOString().substr(0, 10) <= new Date().toISOString().substr(0, 10)
      },
      allowedDateStart(val) {
          return  new Date(val).toISOString().substr(0, 10) <= new Date().toISOString().substr(0, 10)
      },
      getRange(type) {
        let ds = moment(this.periodStart)
        let de = moment(this.periodEnd)

        switch (type) {
          case 'custom':
            this.dateStart = this.pickerDateStart
            this.dateEnd = (this.pickerDateEnd) ? this.pickerDateEnd : this.pickerDateStart
            if (this.pickerDateStart > this.pickerDateEnd) {
              this.dateStart = this.pickerDateEnd
              this.dateEnd = this.pickerDateStart
            }
            break
          case 'period':        
            this.dateEnd = new Date(
                                    Date.UTC(
                                      new Date(ds).getFullYear(),
                                      new Date(ds).getMonth(),
                                      new Date(ds).getDate() - 1)
                                    ).toISOString().substr(0, 10)

            this.dateStart = new Date(
                                      Date.UTC(
                                        new Date(ds).getFullYear(),
                                        new Date(ds).getMonth(),
                                        new Date(ds).getDate() - (this.diff))
                                      ).toISOString().substr(0, 10)
            break
          case 'year':
            
            this.dateEnd = new Date(
                                    Date.UTC(
                                      new Date(de).getFullYear() - 1,
                                      new Date(de).getMonth(),
                                      new Date(de).getDate())
                                    ).toISOString().substr(0, 10)

            this.dateStart = new Date(
                                      Date.UTC(
                                        new Date(ds).getFullYear() - 1,
                                        new Date(ds).getMonth(),
                                        new Date(ds).getDate())
                                      ).toISOString().substr(0, 10)
            break
        }
        // if (index == 0) {
        //   let d = new Date(this.periodStart)
        //   this.dateEnd = new Date(
        //                           Date.UTC(
        //                             new Date(d).getFullYear(),
        //                             new Date(d).getMonth(),
        //                             new Date(d).getDate() - 1)
        //                           ).toISOString().substr(0, 10)

        //   this.dateStart = new Date(
        //                             Date.UTC(
        //                               new Date(d).getFullYear(),
        //                               new Date(d).getMonth(),
        //                               new Date(d).getDate() - this.diff)
        //                             ).toISOString().substr(0, 10)
        // } else {
        //   this.dateStart = range[0]
        //   this.dateEnd = range[1]
        // }

        this.$emit('getDates', { dateStart: this.dateStart, dateEnd: this.dateEnd })
        this.menu1 = false
        this.menu2 = false
      },
      // click() {
      //   this.dateStart = this.pickerDateStart
      //   this.dateEnd = (this.pickerDateEnd) ? this.pickerDateEnd : this.pickerDateStart
      //   if (this.pickerDateStart > this.pickerDateEnd) {
      //     this.dateStart = this.pickerDateEnd
      //     this.dateEnd = this.pickerDateStart
      //   }

      //   this.$emit('getDates', { dateStart: this.dateStart, dateEnd: this.dateEnd})
      //     this.menu1 = false
      //     this.menu2 = false
      // }
  },
  computed: {

  }
};
</script>

<style>

</style>